import { NgModule } from '@angular/core';
import { SchedulerComponent } from './scheduler.component';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FuseSharedModule } from 'sp-office365-layout';
import { LayoutModule } from '@angular/cdk/layout';
import { MbscModule } from '@mobiscroll/angular';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';

const routes = [
    {
        path: 'scheduler',
        component: SchedulerComponent,
    },
];

@NgModule({
    declarations: [SchedulerComponent],
    imports: [
        RouterModule.forChild(routes),
        TranslateModule,
        FuseSharedModule,
        LayoutModule,
        MbscModule,
        MatIconModule,
        MatCardModule,
        MatButtonModule,
    ],
    exports: [SchedulerComponent],
})
export class SchedulerModule {}
